import { useCallback } from "react";
import { isBlank } from "../util/ext";
import { useHistory, useLocation } from "react-router-dom";

export const useEditScreenClose = defaultRoute => {
  const history = useHistory();
  const { state } = useLocation();

  return useCallback(() => {
    const route = isBlank(state) ? defaultRoute : state.from;
    const fullRoute =
      isBlank(state) || !!state.creatorRelative ? `/creator${route}` : route;

    history.push(fullRoute, {
      searchState: isBlank(state) ? {} : state.searchState,
    });
  }, [history, state, defaultRoute]);
};
